import { pdf } from '@react-pdf/renderer';

import {
  createPurchaseOrderWithAttachment,
  updatePurchaseOrderWithAttachment,
} from 'api/purchaseOrder';
import PurchaseOrderPdfTemplate from 'components/pdfs/PurchaseOrderPdfTemplate';
import { SKU } from 'types/sku';

import {
  CreatePurchaseOrderFormValues,
  mapFormValuesToApiPayload,
  mapFormValuesToPdfData,
} from './CreatePurchaseOrderModal.utils';

type CreatePurchaseOrderContext = {
  manufacturerName: string;
  destinationHubName: string;
  shipToContact: string;
  shipToContactPhone: string;
  shipToContactEmail: string;
};

export const downloadPdfBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  try {
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  } finally {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

export const generatePurchaseOrderPdfBlob = async (
  values: CreatePurchaseOrderFormValues,
  context: CreatePurchaseOrderContext,
  skus: SKU[],
) => {
  const pdfData = mapFormValuesToPdfData(values, context, skus);

  return pdf(<PurchaseOrderPdfTemplate data={pdfData} />).toBlob();
};

export const createPurchaseOrderFromForm = async (
  values: CreatePurchaseOrderFormValues,
  context: CreatePurchaseOrderContext,
  skus: SKU[],
) => {
  const fileName = `${values.poNumber || 'purchase-order'}.pdf`;
  const blob = await generatePurchaseOrderPdfBlob(values, context, skus);
  const payload = mapFormValuesToApiPayload(values);

  const result = await createPurchaseOrderWithAttachment(
    blob,
    fileName,
    payload,
  );

  downloadPdfBlob(blob, fileName);

  return result;
};

export const updatePurchaseOrderFromForm = async (
  purchaseOrderId: string,
  values: CreatePurchaseOrderFormValues,
  context: CreatePurchaseOrderContext,
  skus: SKU[],
) => {
  const fileName = `UPDATED-${values.poNumber || 'purchase-order'}.pdf`;
  const blob = await generatePurchaseOrderPdfBlob(values, context, skus);
  const payload = mapFormValuesToApiPayload(values);

  return updatePurchaseOrderWithAttachment(
    purchaseOrderId,
    blob,
    fileName,
    payload,
  );
};
